export function parseIntOrFallback<T>(value: string | undefined | null | unknown, fallback: T): number | T {
    try {
        if (value == null) {
            return fallback;
        }
        const parsed = parseInt(value.toString(), 10);
        if (isNaN(parsed)) {
            return fallback;
        }
        return parsed;
    } catch (err) {
        return fallback;
    }
}
